import { CookiesStoreContext } from 'context/CookieStoreProvider/cookiesStoreContext';
import { type PropsWithChildren, useRef } from 'react';
import { CookiesStore, CookiesStoreState, createCookiesStore } from 'store/useCookiesStore';
import { type StoreApi } from 'zustand';

type CookiesStoreProviderProps = PropsWithChildren<{
    cookieStoreStateFromServer: CookiesStoreState;
}>;

export const CookiesStoreProvider: FC<CookiesStoreProviderProps> = ({
    children,
    cookieStoreStateFromServer: cookieStoreFromServer,
}) => {
    const storeRef = useRef<StoreApi<CookiesStore>>(createCookiesStore(cookieStoreFromServer));

    return <CookiesStoreContext.Provider value={storeRef.current}>{children}</CookiesStoreContext.Provider>;
};
